<template>
    <img
            v-if="selected.vessel.id"
            :src="im"
            :class="['vslimg', { 'fade-in-animation': imageLoaded }]"
            :alt="selected.vessel.name"
            @load="onImageLoad"
    />
</template>
<style>
    .vslimg {
        width: calc(100% - 40px);
        margin: 20px;
        height: 400px;
        image-rendering: pixelated;
        vertical-align: middle;
        object-fit: cover;
        object-position: 50% 50%;

    }

    .vslimgcont:after {
        content: "No Photo";
        display: block;
        position: absolute;
        font-size: 3rem;
        top: 36%;
        left: 50%;
        z-index: 100;
        color: #636363;
        transform: translate(-50%, -50%);
        opacity: 0.5;
    }

    @media (max-width:768px){
        .vslimg {
            margin: 0 !important;
            width: 100%;
            height: 200px;
        }
    }
    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }

    .fade-in-animation {
        animation: fadeIn 0.5s ease-in-out forwards; /* Adjust duration and timing as needed */
    }
</style>
<script>
import axios from 'axios';
import {mapGetters, mapActions} from 'vuex';


export default {
    data(){
       return {
          files: new FormData,
           imageLoaded: false,
       }
    },

   /* created(){
      document.addEventListener('click', this.handlerInputFile, false);
    },*/
    computed: {
        ...mapGetters(['lng', 'show', 'selected']),

        im(){
            if(typeof this.selected.vessel.images[0] === 'undefined') {
              return "/userfiles/default.png";
            }
              return "/userfiles/" + this.selected.vessel.images[0].name;

         }
   },

   methods: {
       ...mapActions(['setImg']),
       onImageLoad() {
           this.imageLoaded = true; // Set imageLoaded to true when the image is loaded
           setTimeout(() => {
               this.imageLoaded = false;
           }, 1000);
       },
   }
}
</script>



// WEBPACK FOOTER //
// Images.vue?615510b5